import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { ORG_TYPES, ROLES } from "components/Common/Constants";
import { useRequiredAccess } from "hooks/useRequiredAccess";
import Connectivity from "./Connectivity";
import Dyno from "./Dyno";

const EolAnalytics = () => {
  const [activeTab, setActiveTab] = useState("heartBeat");
  const checkAccess = useRequiredAccess(
    [ROLES.ADMIN, ROLES.EXECUTIVE, ROLES.TEST_ENGINEER],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );

  useEffect(() => {
    checkAccess();
  });

  const onChangeTab = (key) => {
    setActiveTab(key);
  };

  const items = [
    {
      key: "heartBeat",
      label: `Heart Beat`,
      children: <Connectivity />,
    },
    {
      key: "dyno",
      label: `Dyno`,
      children: <Dyno />,
    },
  ];

  return (
    <Tabs defaultActiveKey={activeTab} items={items} onChange={onChangeTab} />
  );
};

export default EolAnalytics;
